import { CSSProperties } from 'react'
import { Tooltip } from '../../base'
import MmrIconSVG from '../../images/mmr.svg'

export const MmrIcon = ({
  mmrId,
  iconStyle,
  title,
  href,
}: {
  mmrId: string
  iconStyle?: CSSProperties
  title?: string
  href?: string
}) => {
  const icon = <MmrIconSVG style={{ height: 20, ...iconStyle }} />

  return (
    <Tooltip title={title || mmrId}>
      <div style={href ? { display: 'flex' } : undefined}>
        {href ? (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'flex', cursor: 'pointer' }}
          >
            {icon}
          </a>
        ) : (
          icon
        )}
      </div>
    </Tooltip>
  )
}
